'use strict';
/**
 * [init initilizes tabs]
 * @param  {[string]} scope [css selector]
 * @return {[undefined]}    [nothing returned]
 */
export function init(scope){

    $('.gallery-box').on('click', '.gallery-box-thumbnails li', function(){

        $(this).siblings().removeClass('gallery-box-thumbnails--current');

        $(this).addClass('gallery-box-thumbnails--current');

        $(this).parents('.gallery-box').find('.gallery-box-main-image img').attr({
            'src': $(this).find('a').attr('href'),
            'title': $(this).find('img').attr('title')
        });

        return false;
    });

}
